import React from "react";
import { isMobile } from "react-device-detect";
import "./styles.scss";
import { Link } from "react-router-dom";

export default class NewsfeedVideo extends React.Component {
  render() {
    const className = isMobile ? "" : "mt-0";
    return (
      <>
        <div className="mt-0">
          <b style={{ fontSize: 17 }}>New Visuals from the UNIFI Music community</b>
          <div>
            Want your visuals featured here?{" "}
            <a style={{ color: "unset!important", textDecoration: "underline" }} href={"/settings/social-media "}>
              Add your YouTube channel to your profile
            </a>
          </div>
        </div>
        <div className={`newsfeed-video ${className}`}>
          <iframe src={this.props.videoUrl} frameBorder="0" allowFullScreen allowtransparency="true"></iframe>
        </div>
        {/* {this.props.videoDescription && (
          <div
            className={`${className}`}
            dangerouslySetInnerHTML={{
              __html:
                this.props.videoDescription.indexOf("href") >= 0
                  ? this.props.videoDescription.replace(/href/g, "target='_blank' href")
                  : this.props.videoDescription,
            }}
          />
        )} */}
      </>
    );
  }
}
